export default __webpack_public_path__ + "images/0x6ae7dfc73e0dde2aa99ac063dcf7e8a63265108c.png";